<template>
  <v-snackbar :timeout="-1" v-model="appUpdateAvailable" color="darken-2" rounded="pill" bottom right>
    {{ $t("app.update.available") }}
    <template v-slot:action>
      <v-btn @click="refreshApp" color="primary" text small>
        {{ $t("app.update.activate") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import RootStateMixin from "@/mixins/store/RootStateMixin";
import Component, { mixins } from "vue-class-component";
import UpdateHandlerMixin from "@/mixins/UpdateHandlerMixin";

@Component
export default class UpdateHandler extends mixins(RootStateMixin, UpdateHandlerMixin) {}
</script>
